// extracted by mini-css-extract-plugin
var _1 = "DLEleAHnH6";
var _2 = "BzZUuT_eS7";
export { _1 as "disabled", _2 as "root" }
